import { MapBoundsPadding } from './location.types';

export const DEFAULT_LAT = 39.828272
export const DEFAULT_LNG = -98.579469
export const CHARACTER_LIMIT_FACILITY = 50
export const CHARACTER_LIMIT_VEHICLE_COLOR = 7
export const GPS_LOCATION_DISTANCE_WARN_LIMIT = 5
export const MAP_BOTTOM_PADDING_CUSTOM_DESTINATION = 210
export const MAP_BOTTOM_PADDING_CONFIRMED_LOCATION = 400
export const MAP_BOTTOM_PADDING_AAR = 310
export const MAP_BOTTOM_PADDING_EV_STATION = 350
export const MAP_BOTTOM_PADDING_ADDITIONAL_CHARGE_LEVEL = 70
export const MAP_BOUNDS_PADDING: MapBoundsPadding = {
  top: 96,
  left: 32,
  right: 32,
  bottom: 24
}
export const DEFAULT_MIN_ZOOM = 4
export const CITY_LEVEL_ZOOM = 9
export const DEFAULT_MAX_MAP_ZOOM = 19
